import * as moment from "moment-timezone";
import * as _ from "lodash";

import { Component, OnInit, OnDestroy } from "@angular/core";
import { AdrSystemService } from "../../adr-system.service";
import { Domain as WebsideDomain } from "../../../../../lib/Domain/Webside";
import { Domain as LWFSeriesDomain } from "../../../../../lib/Domain/LWFSeries";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

moment.locale("zh-tw");

@Component({
  selector: "app-adr-system",
  templateUrl: "./adr-system.component.html",
  styleUrls: ["./adr-system.component.css"]
})
export class AdrSystemComponent implements OnInit, OnDestroy {
  public AdrsystemLists: LWFSeriesDomain.IDeviceInfo[] = [];
  public selectedGateway: LWFSeriesDomain.IDeviceInfo | undefined = undefined;
  public rdata: LWFSeriesDomain.IRealTimedata = {
    _id: `string`,
    getewayId: `string`,
    meterId: 0,
    timestamp: new Date(1970, 0, 1),
    overTemperatureAlarm: false,
    iceWaterInTemperature: 0,
    iceWaterOutTemperature: 0,
    coolingWaterOutTemperature: 0,
    coolingWaterInTemperature: 0,
    refrigerantTemperature: 0,
    oilTankTemperature: 0,
    averageVoltage: 0,
    averageCurrent: 0,
    averagePower: 0,
    averagePowerFactor: 0,
    averagekW: 0,
    devACurrent: 0,
    devBCurrent: 0,
    devAPower: 0,
    devBPower: 0,
    devAHighPressure: 0,
    devALowPressure: 0,
    devBHighPressure: 0,
    devBLowPressure: 0,
    refrigerantLowTemperatureSetting: 0,
    iceWaterTemperatureSetting: 0,
    temperatureControl: LWFSeriesDomain.TemperatureControlMode.IceWaterIn,
    aDRControlState: false,
    devAMaxLoad: 0,
    devAMaxFrequency: 0,
    devAInverterOutFrequency: 0,
    devBRunning50: false,
    devBRunning75: false,
    devBForceRunning25: false,
    devBForceRunning50: false,
    devBForceRunning75: false,
    devAFailure: false,
    devBFailure: false,
    emergencyStart: false,
    coolingAlarm: false,
    iceWaterAlarm: false,
    antifreezeAlarm: false,
    powerProtectionAlarm: false,
    devAHighPressureAlarm: false,
    devBHighPressureAlarm: false,
    devBOverLoadAlarm: false,
    devACoilAlarm: false,
    devBCoilAlarm: false,
    devALowPressureAlarm: false,
    devBLowPressureAlarm: false,
    devAOilPressureAlarm: false,
    devBOilPressureAlarm: false,
    needMaintenance: false,
    inverterAbnormal: false,
    oilProtection: false,
    refrigerantAbnormal: false,
    iceWaterInSensorAlarm: false,
    iceWaterOutSensorAlarm: false,
    coolingWaterInSensorAlarm: false,
    coolingWaterOutSensorAlarm: false,
    refrigerantLowTemperatureSensorAlarm: false,
    oilTankTemperatureSensorAlarm: false,
    devAState: LWFSeriesDomain.DevARunningState.Stop,
    devBState: LWFSeriesDomain.DevBRunningState.Stop,
    devARunningTime: 0,
    devAStartCount: 0,
    devBRunningTime: 0,
    devBStartCount: 0,
    remoteControlSingal: false
  };
  public filterdate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };

  public powerChart: echarts.EChartOption = {};
  public voltageChart: echarts.EChartOption = {};
  public tempChart: echarts.EChartOption = {};
  public devAchart: echarts.EChartOption = {};
  public devBchart: echarts.EChartOption = {};
  public remoteSingalchart: echarts.EChartOption = {};
  constructor(
    private adrSystemService: AdrSystemService,
    private modalService: NgbModal
  ) {}
  private isTimer = false;
  async ngOnInit() {
    this.isTimer = true;
    this.AdrsystemLists = await this.adrSystemService.List();
    if (this.AdrsystemLists.length > 0) {
      this.onSelected(this.AdrsystemLists[0]);
    }
    this.getHistorical(new Date());
    this.SetTimer();
  }
  ngOnDestroy() {
    this.isTimer = false;
  }

  private SetTimer() {
    const runGet = () => {
      setTimeout(async () => {
        this.AdrsystemLists = await this.adrSystemService.List();
        if (this.selectedGateway !== undefined) {
          this.rdata = await this.adrSystemService.Realtimedata(
            this.selectedGateway.gatewayId,
            this.selectedGateway.meterId
          );
          if (
            moment(
              new Date(
                this.filterdate.year,
                this.filterdate.month - 1,
                this.filterdate.day
              )
            ).format("YYYYMMDD") === moment().format("YYYYMMDD")
          ) {
            // update now
            this.getHistorical(new Date());
          }
        }
        if (this.isTimer) {
          runGet();
        }
      }, 60 * 1000);
    };
    if (this.isTimer) {
      runGet();
    }
  }

  fromNow(date: Date | string) {
    return moment(date).fromNow();
  }
  async onSelected(item: LWFSeriesDomain.IDeviceInfo) {
    this.selectedGateway = item;
    this.rdata = await this.adrSystemService.Realtimedata(
      this.selectedGateway.gatewayId,
      this.selectedGateway.meterId
    );
  }

  public DevARunningState2Cht(data: number): string {
    switch (data) {
      case 0x0:
        return `停機`;
      case 0x1:
        return `延時啟動`;
      case 0x2:
        return `變頻運轉2`;
      case 0x5:
        return `變頻運轉5`;
      case 0x6:
        return `主機故障`;
      case 0x7:
        return `維護中`;
      case 0x8:
        return `溫度到達`;
      case 0x9:
        return `卸載停機中`;
      default:
        return `未知代碼 ${data}`;
    }
  }
  public DevBRunningState2Cht(data: number): string {
    switch (data) {
      case 0x0:
        return `停機`;
      case 0x1:
        return `延時啟動`;
      case 0x2:
        return `容量 25%運轉`;
      case 0x3:
        return `容量 50%運轉`;
      case 0x4:
        return `容量 75%運轉`;
      case 0x5:
        return `容量滿載運轉`;
      case 0x6:
        return `主機故障`;
      case 0x7:
        return `維護中`;
      case 0x8:
        return `溫度到達`;
      case 0x9:
        return `卸載停機中`;
      default:
        return `未知代碼 ${data}`;
    }
  }
  public running2Cht(data: number) {
    return `${(data / 10000).toFixed(0)}日${((data % 10000) / 100).toFixed(
      0
    )}時${((data % 10000) % 100).toFixed(0)}分`;
  }
  public renderControlCSS(onoff: boolean) {
    return onoff ? "bg-danger" : "bg-success";
  }
  public renderAlarmCSS(onoff: boolean) {
    return onoff ? "bg-warning" : "bg-success";
  }

  public OnFind(f: any) {
    const sdate = new Date(
      this.filterdate.year,
      this.filterdate.month - 1,
      this.filterdate.day
    );
    this.getHistorical(sdate);
  }

  public async getHistorical(sdate: Date) {
    const rawdata = await this.adrSystemService.Historicaldata(
      this.selectedGateway.gatewayId,
      this.selectedGateway.meterId,
      sdate
    );

    this.powerChart = {
      title: {
        text: `用電`
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985"
          }
        }
      },
      legend: {
        data: ["平均功率", "電力計"]
      },
      dataZoom: [
        {
          startValue: moment().format("YYYY-MM-DD")
        },
        {
          type: "inside"
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          name: "時間",
          type: "category",
          boundaryGap: false,
          data: _.map(rawdata, v => {
            return moment(v.timestamp).format("HH:mm");
          })
        }
      ],
      yAxis: [
        {
          name: "功率(W)",
          type: "value"
        },
        {
          name: "度數(kWh)",
          type: "value"
        }
      ],
      series: [
        {
          name: "平均功率",
          type: "line",
          yAxisIndex: 0,
          data: _.map(rawdata, v => {
            return parseFloat(v.averagePower.toFixed(1));
          })
        },
        {
          name: "電力計",
          type: "line",
          yAxisIndex: 1,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return parseFloat(v.averagekW.toFixed(1));
          })
        }
      ]
    };
    // voltage
    this.voltageChart = {
      title: {
        text: `電壓電流`
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985"
          }
        }
      },
      legend: {
        data: ["平均電壓", "平均電流"]
      },
      dataZoom: [
        {
          startValue: moment().format("YYYY-MM-DD")
        },
        {
          type: "inside"
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          name: "時間",
          type: "category",
          boundaryGap: false,
          data: _.map(rawdata, v => {
            return moment(v.timestamp).format("HH:mm");
          })
        }
      ],
      yAxis: [
        {
          name: "電壓(V)",
          type: "value"
        },
        {
          name: "電流(A)",
          type: "value"
        }
      ],
      series: [
        {
          name: "平均電壓",
          type: "line",
          yAxisIndex: 0,
          // areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return parseFloat(v.averageVoltage.toFixed(1));
          })
        },
        {
          name: "平均電流",
          type: "line",
          yAxisIndex: 1,
          data: _.map(rawdata, v => {
            return parseFloat(v.averageCurrent.toFixed(1));
          })
        }
      ]
    };
    // tempure
    this.tempChart = {
      title: {
        text: `溫度`
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985"
          }
        }
      },
      legend: {
        data: [
          "冰水入水溫度",
          "冰水出水溫度",
          "冷卻水入水溫度",
          "冷卻水出水溫度",
          "冷媒低溫溫度",
          "油槽溫度"
        ]
      },
      dataZoom: [
        {
          startValue: moment().format("YYYY-MM-DD")
        },
        {
          type: "inside"
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          name: "時間",
          type: "category",
          boundaryGap: false,
          data: _.map(rawdata, v => {
            return moment(v.timestamp).format("HH:mm");
          })
        }
      ],
      yAxis: [
        {
          name: "冷卻水/冰水溫度(°C)",
          type: "value"
        },
        {
          name: "油槽溫度(°C)",
          type: "value"
        }
      ],
      series: [
        {
          name: "冰水入水溫度",
          type: "line",
          yAxisIndex: 0,
          data: _.map(rawdata, v => {
            return parseFloat(v.iceWaterInTemperature.toFixed(1));
          })
        },
        {
          name: "冰水出水溫度",
          type: "line",
          yAxisIndex: 0,
          data: _.map(rawdata, v => {
            return parseFloat(v.iceWaterOutTemperature.toFixed(1));
          })
        },
        {
          name: "冷卻水入水溫度",
          type: "line",
          data: _.map(rawdata, v => {
            return parseFloat(v.coolingWaterInTemperature.toFixed(1));
          })
        },
        {
          name: "冷卻水出水溫度",
          type: "line",
          data: _.map(rawdata, v => {
            return parseFloat(v.coolingWaterOutTemperature.toFixed(1));
          })
        },
        {
          name: "冷媒低溫溫度",
          type: "line",
          data: _.map(rawdata, v => {
            return parseFloat(v.refrigerantTemperature.toFixed(1));
          })
        },
        {
          name: "油槽溫度",
          type: "line",
          yAxisIndex: 1,
          data: _.map(rawdata, v => {
            return parseFloat(v.oilTankTemperature.toFixed(1));
          })
        }
      ]
    };
    // devA
    this.devAchart = {
      title: {
        text: `A機變頻機`
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985"
          }
        }
      },
      legend: {
        data: ["高壓壓力", "低壓壓力", "功率"]
      },
      dataZoom: [
        {
          startValue: moment().format("YYYY-MM-DD")
        },
        {
          type: "inside"
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          name: "時間",
          type: "category",
          boundaryGap: false,
          data: _.map(rawdata, v => {
            return moment(v.timestamp).format("HH:mm");
          })
        }
      ],
      yAxis: [
        {
          name: "壓力(KG)",
          type: "value"
        },
        {
          name: "功率(kW)",
          type: "value"
        }
      ],
      series: [
        {
          name: "高壓壓力",
          type: "line",
          yAxisIndex: 0,
          data: _.map(rawdata, v => {
            return parseFloat(v.devAHighPressure.toFixed(1));
          })
        },
        {
          name: "低壓壓力",
          type: "line",
          yAxisIndex: 0,
          data: _.map(rawdata, v => {
            return parseFloat(v.devALowPressure.toFixed(1));
          })
        },
        {
          name: "功率",
          type: "line",
          yAxisIndex: 1,
          data: _.map(rawdata, v => {
            return parseFloat(v.devAPower.toFixed(1));
          })
        }
      ]
    };
    // devB
    this.remoteSingalchart = {
      title: {
        text: `遙控啟動訊號`
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985"
          }
        }
      },
      legend: {
        data: [
          "需量控制訊號",
          "遠控信號",
          "B機需量運轉率50%",
          "B機需量運轉率75%",
          "B機強制運轉率75%",
          "B機強制運轉率50%",
          "B機強制運轉率25%"
        ]
      },
      dataZoom: [
        {
          startValue: moment().format("YYYY-MM-DD")
        },
        {
          type: "inside"
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          name: "時間",
          type: "category",
          boundaryGap: false,
          data: _.map(rawdata, v => {
            return moment(v.timestamp).format("HH:mm");
          })
        }
      ],
      yAxis: [
        {
          name: "控制訊號",
          type: "value"
        },
        {
          name: "運轉率訊號",
          type: "value"
        }
      ],
      series: [
        {
          name: "需量控制訊號",
          type: "line",
          yAxisIndex: 0,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return v.aDRControlState ? 1 : 0;
          })
        },
        {
          name: "遠控信號",
          type: "line",
          yAxisIndex: 0,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return v.remoteControlSingal ? 1 : 0;
          })
        },
        {
          name: "B機需量運轉率50%",
          type: "line",
          yAxisIndex: 1,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return v.devBRunning50 ? 1 : 0;
          })
        },
        {
          name: "B機需量運轉率75%",
          type: "line",
          yAxisIndex: 1,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return v.devBRunning75 ? 1 : 0;
          })
        },
        {
          name: "B機強制運轉率75%",
          type: "line",
          yAxisIndex: 1,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return v.devBForceRunning75 ? 1 : 0;
          })
        },
        {
          name: "B機強制運轉率50%",
          type: "line",
          yAxisIndex: 1,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return v.devBForceRunning50 ? 1 : 0;
          })
        },
        {
          name: "B機強制運轉率25%",
          type: "line",
          yAxisIndex: 1,
          areaStyle: { normal: {} },
          data: _.map(rawdata, v => {
            return v.devBForceRunning25 ? 1 : 0;
          })
        }
      ]
    };
    // devB
    this.devBchart = {
      title: {
        text: `B機定頻機`
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985"
          }
        }
      },
      legend: {
        data: ["高壓壓力", "低壓壓力", "功率"]
      },
      dataZoom: [
        {
          startValue: moment().format("YYYY-MM-DD")
        },
        {
          type: "inside"
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          name: "時間",
          type: "category",
          boundaryGap: false,
          data: _.map(rawdata, v => {
            return moment(v.timestamp).format("HH:mm");
          })
        }
      ],
      yAxis: [
        {
          name: "壓力(KG)",
          type: "value"
        },
        {
          name: "功率(kW)",
          type: "value"
        }
      ],
      series: [
        {
          name: "高壓壓力",
          type: "line",
          yAxisIndex: 0,
          data: _.map(rawdata, v => {
            return parseFloat(v.devBHighPressure.toFixed(1));
          })
        },
        {
          name: "低壓壓力",
          type: "line",
          yAxisIndex: 0,
          data: _.map(rawdata, v => {
            return parseFloat(v.devBLowPressure.toFixed(1));
          })
        },
        {
          name: "功率",
          type: "line",
          yAxisIndex: 1,
          data: _.map(rawdata, v => {
            return parseFloat(v.devBPower.toFixed(1));
          })
        }
      ]
    };
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Page/adr-system/adr-system.component.ts